<template>
  <div>
    <NavMenu />
    <div style="min-height: 500px; margin-top: 150px;">
      <router-view />
    </div>
    <FooterCom />
  </div>
</template>
<script>
import NavMenu from './components/navManu.vue'
import FooterCom from './components/footerCom.vue'
import 'animate.css'

export default {
  name: 'App',
  components: {
    NavMenu,
    FooterCom
  }
}
</script>

<style>
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #502c2c;
}
</style>
